module.exports = __webpack_public_path__ + "media/images/features/7/plan-album1-1a4a7b0967d18318de0aa9096891f4f6.jpg";